import * as Sentry from "@sentry/react"
import env from "config/env"
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom"
import { useEffect } from "react"

const isProd = env.environment === "production"
const enabled = Boolean(env.sentryDsn) && (isProd || env.sentryEnabled === "true")

const apiHostPattern = (() => {
	try {
		const origin = new URL(env.socketRoot).origin
		return new RegExp(`^${origin.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`)
	} catch {
		return /^http:\/\/localhost(:\d+)?/
	}
})()

Sentry.init({
	dsn: env.sentryDsn,
	environment: env.environment || process.env.NODE_ENV,
	release: `${env.sentryProject}@1.0.0` || undefined,
	enabled,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
		Sentry.replayIntegration({
			maskAllText: false,
			maskAllInputs: false,
			blockAllMedia: false,
		}),
	],
	tracesSampleRate: isProd ? 0.2 : 1.0,
	replaysSessionSampleRate: isProd ? 0.1 : 0,
	replaysOnErrorSampleRate: 1.0,
	tracePropagationTargets: [apiHostPattern],
	beforeSend(event: any) {
		return event
	},
})
